import React from 'react';
import logo from './images/logo.png';
import threeDots from './images/threeDots.webp';
import fourDots from './images/fourDots.webp';

function Header({ onMenuClick }) {
  return (
    <section className="menuPart">
      <div className="container">
        <div className="topArea">
          <div></div>
          <div className="logo">
            <a href="/">
              <img src={logo} className="img-fluid" alt="Drinkwatr Logo" />
            </a>
          </div>
          <div className="menuClick" onClick={onMenuClick}>
            <img src={fourDots} className="mobIcon" alt="Menu" />
            <div class="deskMenuStyle deskT">
              <img src={fourDots} class="img-fluid " />
              <p>Discover</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Header;